import * as React from "react";
function SvgGraphPodium(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M0 29h32"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M8 12v13M16 3v22M24 16v9"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGraphPodium);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
